<div class="browse-sidebar__head">
  <span class="browse-sidebar__title">Folders</span>

  <svg
    (click)="onCloseIconClick()"
    class="browse-sidebar__close-icon"
    width="13"
    height="23"
    viewBox="0 0 13 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line x1="0.993089" y1="12.2929" x2="11.5997" y2="1.68629" stroke="#334152" stroke-width="2" />
    <line x1="1.70711" y1="11.6132" x2="11.6066" y2="21.5127" stroke="#334152" stroke-width="2" />
  </svg>
</div>

<ng-template [ngIf]="!nodesLoading">
  <ng-template [ngIf]="nodes?.length" [ngIfElse]="noResults">
    <ul class="browse-sidebar__list">
      <li
        class="browse-sidebar__list-item"
        [ngClass]="{'browse-sidebar__list-item--select': isNodeSelected(node)}"
        *ngFor="let node of nodes; trackBy: trackByParentNode"
        (click)="onNodeClick(node)"
      >
        <i class="browse-sidebar__list-item-icon fa fa-envelope" aria-hidden="true"></i>
        <span class="browse-sidebar__list-item-value">
          {{ node.label }}
        </span>
      </li>
    </ul>
  </ng-template>

  <ng-template #noResults>
    <div class="browse-sidebar__no-results">
      <span class="browse-sidebar__no-results-message">No results found</span>
    </div>
  </ng-template>
</ng-template>
